import ClipboardData from './clipboardData';

export default class PasteEvent {
  constructor() {
    this.clipboardData = new ClipboardData();
  }
}



// WEBPACK FOOTER //
// ./node_modules/handsontable/src/plugins/copyPaste/pasteEvent.js